import { rolesService } from '../../services';

// initial state
const state = {
    all: [],
};

// getters
const getters = {};

// actions
const actions = {
    getAll ({ dispatch, commit }) {
        return rolesService
            .getAll()
            .then((nodes) => {
                commit('setNodes', nodes);
            })
            .catch((error) => {
                commit('setNodes', []);
                dispatch('alert/error', error, { root: true });

                return error;
            });
    },
    getSelected ({ dispatch, commit }, style) {
        return rolesService
            .getSelected(style)
            .then((nodes) => {
                commit('setNodes', nodes);
            })
            .catch((error) => {
                commit('setNodes', []);
                dispatch('alert/error', error, { root: true });

                return error;
            });
    },
};

// mutations
const mutations = {
    setNodes (state, nodes) {
        state.all = nodes;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
